/**
 * @generated SignedSource<<58322ee2638f5feedd22b7d66196f00c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type serviceCredits_fragmentServiceCreditQuery$variables = {
  serviceName: ServicesWithCredits;
};
export type serviceCredits_fragmentServiceCreditQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"serviceCreditsServiceCredit_fragment">;
};
export type serviceCredits_fragmentServiceCreditQuery = {
  response: serviceCredits_fragmentServiceCreditQuery$data;
  variables: serviceCredits_fragmentServiceCreditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "serviceName",
    "variableName": "serviceName"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceCredits_fragmentServiceCreditQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "serviceCreditsServiceCredit_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceCredits_fragmentServiceCreditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceCredit",
        "kind": "LinkedField",
        "name": "serviceCredit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceCreditID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "service",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "credit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoRefill",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unlimitedCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trialCreditsUsed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSellerPurchasedCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "183f1057ce14ff914164423b3b54ca1e",
    "id": null,
    "metadata": {},
    "name": "serviceCredits_fragmentServiceCreditQuery",
    "operationKind": "query",
    "text": "query serviceCredits_fragmentServiceCreditQuery(\n  $serviceName: ServicesWithCredits!\n) {\n  ...serviceCreditsServiceCredit_fragment_4E6Gnr\n}\n\nfragment serviceCreditsServiceCredit_fragment_4E6Gnr on Query {\n  serviceCredit(serviceName: $serviceName) {\n    serviceCreditID\n    service\n    credit\n    autoRefill\n    unlimitedCredits\n    trialCreditsUsed\n    hasSellerPurchasedCredits\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "547ffe4161fad5900346da4c6927d8f9";

export default node;
